/* eslint-disable */
import { useEffect } from 'react';
import { achievementTriggers } from '../utils/achievementTriggers';
import { useAuth } from '../contexts/AuthContext';

export const useAuthActions = () => {
  const { user } = useAuth();
  
  // Reset daily login tracking on user change
  useEffect(() => {
    if (!user?.id) {
      window.dailyLoginTracked = false;
    }
  }, [user?.id]);

  // Track daily login (only once per session)
  useEffect(() => {
    if (user?.id && !window.dailyLoginTracked) {
      const trackLogin = async () => {
        try {
          const today = new Date().toDateString();
          const lastLogin = localStorage.getItem('lastLoginDate');
          
          // Only track if it's a new day
          if (lastLogin !== today) {
            await achievementTriggers.dailyLogin(user.id);
            localStorage.setItem('lastLoginDate', today);
          }
          
          window.dailyLoginTracked = true;
        } catch (error) {
          console.error('Error tracking daily login:', error);
        }
      };
      
      trackLogin();
    }
  }, [user?.id]);

  return {};
};